class CapitalGainAmount {
    crowdfundingPropertyYearsToSale;
    numberOfBricks;
    capitalGain;
    constructor(data) {
        this.crowdfundingPropertyYearsToSale = data.crowdfundingPropertyYearsToSale;
        this.numberOfBricks = data.numberOfBricks;
        this.capitalGain = data.capitalGain;
    }
}
export default CapitalGainAmount;
